module.controller('sampleInterpretWizardCtrl', [ '$timeout', '$scope', '$rootScope', '$state', 'planSamplingService','reportService','alertService','dateUtilService', sampleInterpretWizardCtrlFn ]);
function sampleInterpretWizardCtrlFn($timeout, $scope, $rootScope, $state, planSamplingService,reportService,alertService,dateUtil) {

	var vmParent = $scope.$parent;
	var vm = $scope;

	var currentIndexSample = -1;

	vm.samples = [];
	
	vm.validation = {
			observations : {
				maxlength : 500
			}
	};

	var interpretInfoInit = {
			result : [],
			observations : ""
	}

	vm.interpretInfo = cloneObject(interpretInfoInit);

	vm.onTransition = true;
	/*
	 * se limpua la bandera cuanto termina de cargar la muestra
	 */
	vm.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
		var emptyParams = (toState.name === "home.sampleInterpret.wizard.sample" && toParams.idSample == null);
		// si fue un F5 o una actualización de la página lo lleva a la pantalla
		// donde seleciona de nuevo las muestras
		if (emptyParams && fromState.url == "^") {
			$state.go('home.sampleInterpret.select');
			return;
		}
		// si se hizo la transaccion correcta borra la bandera
		$scope.onTransition = emptyParams;
	});
	/*
	 * obtiene el objeto del formutario
	 */
	vm.getForm = function() {
		if ($scope.$$childTail == null)
			return null;
		if ($scope.$$childTail.$$prevSibling == null)
			return null;
		return $scope.$$childTail.$$prevSibling.interpretSampleForm;
	}
	/*
	 * Es el primer elemento de la lista?
	 */
	vm.isFirst = function() {
		return (currentIndexSample <= 0);
	}
	/*
	 * Es el último elemento de la lista?
	 */
	vm.isLast = function() {
		return (currentIndexSample == vm.samples.length -1);
	}
	/*
	 * Obtiene la infromacion de la muestra actual
	 */
	vm.getCurrentSample = function(){
		if (currentIndexSample < 0 || currentIndexSample >= vm.samples.length)
			return;
		return vm.samples[currentIndexSample];
	}
	/*
	 * Genera un next en el wizard
	 */
	vm.simulateNextClick = function(){
		var $this = $("#myWizard");
		var data = $this.data('wizard');
		data.next();
	}
	/*
	 * Muestra sigueinte
	 */
	function nextSample() {
		if (currentIndexSample >= vm.samples.length || vm.samples.length == 0)
			return;
		var ss = vm.samples[++currentIndexSample]
		changeView(ss.planSampling.id, ss.sampling.id, ss.id);
	}
	/*
	 * Muestra anterior
	 */
	function prevSample() {
		if (currentIndexSample < 0)
			return;
		var ss = vm.samples[--currentIndexSample];
		changeView(ss.planSampling.id, ss.sampling.id, ss.id);
	}
	/*
	 * Carga la información de la muestra
	 */
	function changeView(idPlan, idSampling, idSample) {
		$scope.onTransition = true;
		$state.go('home.sampleInterpret.wizard.sample', {
			idPlan : idPlan,
			idSampling : idSampling,
			idSample : idSample
		}, {
			location : false,
			reload : true
		});
	}
	/*
	 * se pone en la correpondiente muestra el valor de la interpretación
	 */
	function setInterpretInfo() {
		var index = currentIndexSample;
		if (index < 0 || index >= vm.samples.length)
			return;
		vm.samples[index].interpretInfo = cloneObject(vm.interpretInfo);
		vm.interpretInfo = cloneObject(interpretInfoInit);
	}
	/*
	 * se pone enel objeto del formulario la informacvion suministrada de
	 * interpretación
	 */
	function getInterpretInfo() {
		var index = currentIndexSample;
		if (index < 0 || index >= vm.samples.length)
			return;
		if(angular.isUndefined(vm.samples[index].interpretInfo))
			vm.samples[index].interpretInfo = cloneObject(interpretInfoInit);
		vm.interpretInfo = cloneObject(vm.samples[index].interpretInfo);
	}
	/*
	 * Inicia las funcionalidades del wizard
	 */
	function initWizard() {
		$('#myWizard').wizard();
		$('#myWizard').on("stepclick", onClickStep);
		$('#myWizard').on("change", onChangeStep);
		$('#myWizard').on("finished", onFinishWizard);
	}
	/*
	 * Envia las muestras a reportar
	 */
	function onFinishWizard() {
		setInterpretInfo();
		
		var createModel = {
		reportClientSample : []
		};
		
		for (i = 0; i < vm.samples.length; i++) {
			var interpret = {						 
					idSample:vm.samples[i].id,
					idSampling: vm.samples[i].sampling.id,
					interpretation:vm.samples[i].interpretInfo.observations,
				    interpretResult: vm.samples[i].interpretInfo.result["0"].enumName,					
					idClientArea:vm.samples[i].area.id,
					idClientSite: vm.samples[i].site.id
			}
			createModel.reportClientSample.push(interpret);
		}
					
		alertService.showSwtQuestion('Enviar Reporte de muestras', function() {
			vm.loading = true;
			
			reportService.create(vm.samples["0"].client.id,vm.samples["0"].planSampling.id,createModel).then(function(response) {
			
			alertService.showSuccess('Muestra Reportada satisfactoriamente');
			
			
			$state.go('home.reportClientList',{idClient : vm.samples["0"].client.id, idPlan: vm.samples["0"].planSampling.id});

			vm.loading = false;
			}, function(response) {
				vm.loading = false;
			});
		});
		
		
		console.log("finaliza");
	}
	/*
	 * Navega por el wizard con las flechas, cambia la vista de la muestra
	 */
	function onChangeStep(step, direction) {
		if (angular.isUndefined(direction)) {
			return;
		}
		$scope.onTransition = true;

		if (direction.direction == "previous"){
			setInterpretInfo();
			prevSample();
			getInterpretInfo();
		}
		else{
			setInterpretInfo();
			nextSample();
			getInterpretInfo();
		}
	}
	/*
	 * si se hace click en algun step del wizard
	 */
	function onClickStep(event, step) {
		setInterpretInfo();
		currentIndexSample = step.step - 1;
		getInterpretInfo();
		var ss = vm.samples[currentIndexSample]
		changeView(ss.planSampling.id, ss.sampling.id, ss.id);
	}
	/*
	 * Se ejecuta al iniciar el controlador
	 */
	function init() {

		var ss = vmParent.samplesSelected.items;
		if (Array.isArray(ss)) {
			vm.samples = ss;
		} else {
			vm.samples = [ ss ];
		}

		nextSample();

		// se hace de forma retrazada, para que se puedan genrar los elementos
		// del wizard
		$timeout(initWizard, 100);
	}

	init();
}